import { Component, OnInit } from '@angular/core';
import { HomeService } from '@sc/pas-common';

@Component({
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss']
})

export class NewsComponent implements OnInit {

    newsUrl: string;
    public urlLoaded = false;

    constructor(private _homeService: HomeService) {}

    ngOnInit() {
        this.getNewsUrl();
    }

    getNewsUrl() {
        this._homeService.getShowNewsModal().subscribe(
            (response : any) => {
                this.newsUrl = response.path;
                this.urlLoaded = false;
            }
        );
    }

    onLoaded(event) {
        this.urlLoaded = true;
    }
}
